export const SELECTED_TYPES = {
  option: "option",
  optionValue: "optionValue",
};
